<ng-template #modalTemplate>
  @if (showHeader) {
    <div class="modal-header {{ headerClass }}">
      <h1 class="full-width text-align-center">
        @if (headerIcon) {
          <i class="fal {{ headerIcon }}"></i>
        }
        {{ title }}
      </h1>
      <button
        type="button"
        (click)="hide()"
        class="btn btn-icon close"
        aria-label="Close"
      >
        <span class="fal fa-times" aria-hidden="true"></span>
      </button>
    </div>
  }
  <div class="modal-body">
    <ng-content select=".app-modal-body"></ng-content>
  </div>
  @if (showFooter) {
    <div class="modal-footer">
      <ng-content select=".app-modal-footer"></ng-content>
    </div>
  }
</ng-template>
